import { Injectable } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { ApplicationProxyService } from '../../shared/services/applicationproxy.service';
import { DTMService } from '../../shared/services/dtm.service';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { LoggerService } from '../../shared/services/logger.service';
import { ApplicationActions } from '../../actions/application.actions';
import { Router } from '@angular/router';
import { timer } from 'rxjs/observable/timer';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import moment from 'moment';

@Injectable()
export class TimeOutService {

  /* private  */ _timedOut$ = new BehaviorSubject(false);
  /* readonly */ timedOut$ = this._timedOut$.asObservable();

  constructor(modal: ModalService,
     router: Router,
     dtm: DTMService,
     appActions: ApplicationActions,
     appProxy: ApplicationProxyService,
     flowManager: FlowManagerService,
     logService: LoggerService) {
    this.dtm = dtm;
    this.modal = modal;
    this.router = router;
    this.appProxy = appProxy;
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.logService = logService;

    this.extend = true;

    this.timer = timer(1000, 1000);
    this.timerSubscription = this.timer.subscribe(i => this.ping(i));

    this.timeoutMinutes = 30;
    this.needsPing = false;

    this.modalShown = false;
  }

  async ping(i) {
    if (this.timeoutTime === undefined) {
      this.extendTimeout();
    }

    if (this.extend === true || this.needsPing === true || this.logService.logQueue.length > 0) {
      this._pong();
    }

    const timeLeft = moment(this.timeoutTime).diff(moment(), 'seconds');
    const isTimedOut = moment().isAfter(this.timeoutTime);
    const showWarning = moment().isAfter(moment(this.timeoutTime).subtract(1, 'minutes'));

    if (showWarning === true && this.modalShown === false) {
      this.modalShown = true;
      this.showTimeoutModal();
    }

    if (isTimedOut === true && this._timedOut$.getValue() === false) {
      this._timedOut$.next(true);
      this.dtm.triggerTimeoutEvent();
      this.appActions.setData('sendDTM', true);
      await this.appProxy.clearSession();
      this.modal.closeModal('timedout');
      this.timerSubscription.unsubscribe();

    } else if (this._timedOut$.getValue() === true) {
      this._timedOut$.next(false);
    }

    // Cap time we send to the event at 0 so we don't go negative
    this.modal.timerEvent.emit(Math.max(timeLeft, 0));
  }

  _pong() {
    this.appProxy.ping({ extend: this.extend, logArray: this.logService.getLoggerQueue() }, () => {
      // Dont care
    });
    this.extend = false;
    this.needsPing = false;
  }

  modalClosed() {
    this.modalShown = false;
    this.extendTimeout();
  }

  extendTimeout() {
    if (this.modalShown === false) {
      this.extend = true;
      this.timeoutTime = moment().add(this.timeoutMinutes, 'minutes');
    }
  }

  showTimeoutModal() {
    this.modal.setModalData({
      modalType: 'non-closable',
      fukTopRight: 'false',
      modalClass: 'timeout-above-modal',
      modalBackClass: 'timeout-background',
      title: 'Still there?',
      body: `<div class='margin-bottom-5'>
        For Security reasons this page will timeout in:</div>`,
      timeout: true,
      buttons: [
        {
          id: 'return_application',
          classes: 'btn mobile-primary',
          action: 'extendTimeout',
          text: 'Return To Application'
        },
        {
          id: 'leave_application',
          classes: 'btn-secondary',
          action: 'leaveApp',
          text: 'Leave Application'
        }
      ]
    });
    this.router.navigate([{ outlets: { timeout: 'show' } }], { queryParamsHandling: 'preserve' });
  }

}
